import { useQuery } from '@tanstack/react-query';
import { getWorkspace } from '@/api/workspaces.api';

const WORKSPACE_QUERY_KEY = 'workspace';

export function useWorkspace() {
  return useQuery({
    queryKey: [WORKSPACE_QUERY_KEY],
    queryFn: getWorkspace,
  });
}

export function useMemberName(userId: string | undefined): string | undefined {
  const { data: workspace } = useWorkspace();
  return workspace?.members?.find((m) => m.id === userId)?.name;
}
